import React from 'react';

import Input from '@ott/input';
import { l10n } from '@ott/l10n';

import { dataLocators, fieldsNames } from '../../../constants';
import { transforms } from '../../../helpers';
import { useCreditCardContext } from '../../../provider';

import styles from './DatesInput.scss';

const monthTransforms = transforms[fieldsNames.month];
const yearTransforms = transforms[fieldsNames.year];

const DATE_MAX_LENGTH = 2;

export const DatesInput = () => {
  const {
    isSavedCard,
    cardToDisplay,

    touchField,
    changeFieldValue,
    focusFieldByName,
    checkIfFieldInvalid,
  } = useCreditCardContext();

  const handleMonthChange = (value: string) => {
    changeFieldValue(fieldsNames.month, value);

    if (value.length >= DATE_MAX_LENGTH) {
      focusFieldByName(fieldsNames.year);
    }
  };

  const handleYearChange = (value: string) => {
    changeFieldValue(fieldsNames.year, value);

    if (value.length >= DATE_MAX_LENGTH) {
      focusFieldByName(fieldsNames.cvv);
    }
  };

  return (
    <div className={styles.date}>
      <Input
        className={styles.month}
        label={l10n('paymentCardNew.monthPlaceholder')}
        autoComplete="cc-exp-month"
        formatter={monthTransforms.format}
        parser={monthTransforms.parse}
        name={fieldsNames.month}
        value={cardToDisplay[fieldsNames.month]}
        onChange={handleMonthChange}
        onBlur={() => touchField(fieldsNames.month)}
        hasError={checkIfFieldInvalid(fieldsNames.month)}
        isDisabled={isSavedCard}
        type={isSavedCard ? 'password' : undefined}
        inputMode="numeric"
        specificLocators={dataLocators.month}
      />

      <Input
        className={styles.year}
        label={l10n('paymentCardNew.yearPlaceholder')}
        autoComplete="cc-exp-year"
        formatter={yearTransforms.format}
        parser={yearTransforms.parse}
        name={fieldsNames.year}
        value={cardToDisplay[fieldsNames.year]}
        onChange={handleYearChange}
        onBlur={() => touchField(fieldsNames.year)}
        hasError={checkIfFieldInvalid(fieldsNames.year)}
        isDisabled={isSavedCard}
        type={isSavedCard ? 'password' : undefined}
        inputMode="numeric"
        specificLocators={dataLocators.year}
      />
    </div>
  );
};
